import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles({
  layoutBar: {
    width: '100%',
    '&.top': {
      top: '0 !important',
    },
    '&.bottom': {
      bottom: '0 !important',
    },
    '&.static': {
      position: 'static',
    },
    '&.fixed': {
      position: 'sticky',
      left: 0,
      right: 0,
      zIndex: 20,
    },
    '&.device-fixed': {
      position: 'fixed',
      left: 0,
      right: 0,
      zIndex: 20,
      width: '100%',
    },
    '&.overlay': {
      position: 'sticky',
      background: 'transparent !important',
    },
    '&.shadow': {
      // TODO: this fixes the iOS scroll jump temporary but shadow should be red from theme
      boxShadow: '0 2px 12px 0 rgba(0, 0, 0, 0.2)',
    },
  },
});

export default useStyle;
